import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useTypedDispatch } from "store";
import {
  canAccessMarketAreas,
  isMarketAreaAccessPending,
} from "store/selectors/marketAreas";
import { fetchMarketAreasAvailability } from "features/MarketAreas/MarketAreasActions";

export const useMarketAreaAvailability = () => {
  const canAccess = useSelector(canAccessMarketAreas);
  const isPending = useSelector(isMarketAreaAccessPending);
  return { canAccess, isPending };
};

export const useMarketAreaAvailabilityLoader = () => {
  const dispatch = useTypedDispatch();

  useEffect(() => {
    dispatch(fetchMarketAreasAvailability());
  }, [dispatch]);
};
